import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=dd456b58&scoped=true"
import script from "./TicketForm.vue?vue&type=script&lang=js"
export * from "./TicketForm.vue?vue&type=script&lang=js"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=dd456b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd456b58",
  null
  
)

export default component.exports